export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transactions-list.vue?vue&type=template&id=a349cafe"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/transactions-list.vue?vue&type=template&id=a349cafe
// module id = Iwls
// module chunks = 0